export default {
  type: "row",
  style: "",
  data: {
    applyImageTo: "row",
    applyBackgroundTo: "row",
    stackOnMobile: "off",
  },
  children: [
    {
      type: "col",
      style: "",
      className: "rip-mm-col rip-mm-col-md-4",
      children: [],
    },
    {
      type: "col",
      style: "",
      className: "rip-mm-col rip-mm-col-md-4",
      children: [],
    },
    {
      type: "col",
      style: "",
      className: "rip-mm-col rip-mm-col-md-4",
      children: [],
    },
  ],
};
